import { userConstants } from "../../constants/ActionTypes";

const initialState = {
  openModal:false,
  prefix_number:"",
  edit_prefix_number:"",
  openEditPrefix:false,
  prefix_id:"",
  list:[]  
};

export function prefix(state = initialState, action) {
    switch (action.type) {  
        case userConstants.PREFIX:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}